import { render, staticRenderFns } from "./SummaryCardBodyMapHandsFeet.vue?vue&type=template&id=792686a6&"
import script from "./SummaryCardBodyMapHandsFeet.vue?vue&type=script&lang=js&"
export * from "./SummaryCardBodyMapHandsFeet.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/cards/das-card.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports